import { render, staticRenderFns } from "./MenuPopupItem.vue?vue&type=template&id=624f0710&scoped=true&"
import script from "./MenuPopupItem.vue?vue&type=script&lang=js&"
export * from "./MenuPopupItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuPopupItem.vue?vue&type=style&index=0&id=624f0710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f0710",
  null
  
)

export default component.exports